<template>
    <el-cascader
        :key="cascaderRenderKey"
        :options="displayOptions"
        :props="{ checkStrictly: true, expandTrigger: 'hover', value: 'id', label: 'name', children: 'childList' }"
        :placeholder="inputPlaceholder || $t('app.pleaseSelectFault')"
        clearable
        @change="changeOption"
        v-model="result"
        ref="cascader"
    >
    </el-cascader>
</template>


<script>
import {
    queryDictionarySalesListByParent,
} from "@/api/SquirrelSettlement";
import { normalizeDictionaryLocale, transformFaultClassificationSalesTreeForDisplay } from '@/i18n/dictionary';

/** 与接口约定：queryDictionarySalesListByParent({ typeId: 6076 })，树节点含 type 7777 / 6076 等 */
const FAULT_SALES_TREE_REQUEST_TYPE_ID = 6076;

export default {
    data() {
        return {
            rawTree: [],
            displayOptions: [],
            result: [],
        };
    },
    props: {
        inputPlaceholder: {
            type: String,
            default: ""
        },
    },
    computed: {
        cascaderRenderKey() {
            const loc = normalizeDictionaryLocale(this.$i18n.locale);
            return `fault-cascader-${loc}-${this.rawTree.length}`;
        },
    },
    watch: {
        rawTree: {
            deep: true,
            handler() {
                this.rebuildDisplayOptions();
            },
        },
        '$i18n.locale'() {
            this.rebuildDisplayOptions();
        },
    },
    methods: {
        rebuildDisplayOptions() {
            if (!this.rawTree || !this.rawTree.length) {
                this.displayOptions = [];
                return;
            }
            this.displayOptions = transformFaultClassificationSalesTreeForDisplay(
                this.rawTree,
                this.$i18n.locale
            );
        },
        initOption() {
            queryDictionarySalesListByParent({ typeId: FAULT_SALES_TREE_REQUEST_TYPE_ID }).then(res => {
                if (res.code === 0) {
                    this.rawTree = res.data || [];
                }
            })

        },
        changeOption(node) {
            this.$emit("changeP", this.result);
        },
        resetCascaderInput() {
            this.result = [];
        }
    },
    mounted() {
        this.initOption()
    },
};
</script>

<style lang="scss" scoped></style>
